import { Injector, Optional, Pipe, PipeTransform } from '@angular/core';
import { IFormRule, FormElementRegistry, ViewRuleRegistry, Farris, IFieldViewRule, FrameContext } from '@farris/devkit';

@Pipe({ name: 'elementVisibility' })
export class ElementVisibilityPipe implements PipeTransform {
  constructor(private injector: Injector, private formElementRegistry: FormElementRegistry, private viewRuleRegistry: ViewRuleRegistry, @Optional() private frameContext: FrameContext) { }
  /**
   * è½¬æ¢å­æ®µæ¯å¦å¯è§å¼
   * @param value - å½åè®¡ç®ç
   * @param elementId - åç´ id
   * @param version - trackerä¸­ççæ¬
   */
  transform(value: any, elementId: string, version: any) {
    if (!this.formElementRegistry) {
      return value;
    }
    // è·ååç´ éç½®
    const viewElement = this.formElementRegistry.getElementById(elementId);
    if (!viewElement) {
      return value;
    }
    const binding = viewElement.binding;
    // è·åçé¢è§å
    if (!this.viewRuleRegistry) {
      return value;
    }
    let viewRule = this.viewRuleRegistry.getRuleById(binding) as IFieldViewRule;
    if (!viewRule) {
      const isObjectField = binding && binding.indexOf('.') > -1;
      // å¦ææ¯å¯¹è±¡å­æ®µï¼åå°è¯è·åç¶çº§è§å
      if (isObjectField) {
        const parentBinding = binding.substring(0, binding.indexOf('.'));
        viewRule = this.viewRuleRegistry.getRuleById(parentBinding) as IFieldViewRule;
      }
      if (!viewRule) {
        return value;
      }
    }
    // è·åå°äºåç«¯è§å
    const ruleVisible = viewRule.visibility;
    if (typeof ruleVisible !== 'boolean') {
      // æ æè§å
      return value;
    }
    const configRule = viewElement.rules.find((rule: IFormRule) => rule.type === Farris.FormRule.RuleType.Visible);
    // å¦æè§åæ¯å¯è§ï¼åæç»åºä¸ºæ¡ä»¶å¯è§æå¯è§
    if (ruleVisible) {
      if (configRule.dynamic) {
        return value;
      }
      return true;
    }
    // åç´ å³å°éèï¼ç¦ç¨æ ¡éª
    if (!this.frameContext) {
      this.frameContext = this.injector.get<FrameContext>(FrameContext, null);
    }
    if (this.frameContext) {
      const formControls = this.frameContext.form.ngFormControls;
      if (!formControls || Object.keys(formControls).length < 1) {
        return;
      }
      const entire = Object.entries(formControls);
      for (const [propertyName, formControl] of entire) {
        let formControlBinding = formControl.binding;
        const bindingPaths = this.frameContext.viewModel.bindingPath.split('/').filter((p) => p);
        if (bindingPaths.length > 0) {
          formControlBinding = bindingPaths.join('.') + '.' + formControlBinding;
        }
        if (binding === formControlBinding) {
          this.frameContext.form.setIsShowmap(propertyName, false);
          break;
        }
      }
    }
    return false;
  }
}
